import { useLocation } from 'react-router-dom';

export function useSearchQueryParams() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const params: { [key: string]: string } = {};

  for (const param of searchParams) {
    params[param[0]] = param[1];
  }

  return params;
}
